module.exports = __webpack_public_path__ + "static/media/VCG41617585588.1a6c0552.jpg";